import React from 'react';
import { Navigate } from 'react-router-dom';
import { useCognitoAuth } from '../contexts/CognitoAuthContext';

interface CognitoProtectedRouteProps {
  children: React.ReactNode;
}

const CognitoProtectedRoute: React.FC<CognitoProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, loading, user } = useCognitoAuth();

  console.log('CognitoProtectedRoute: Checking auth - loading:', loading, 'isAuthenticated:', isAuthenticated, 'user:', user);

  if (loading) {
    console.log('CognitoProtectedRoute: Still loading, showing loading screen');
    return <div className="loading-container">Loading...</div>;
  }

  if (!isAuthenticated) {
    console.log('CognitoProtectedRoute: Not authenticated, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  console.log('CognitoProtectedRoute: Authenticated, rendering children');
  return <>{children}</>;
};

export default CognitoProtectedRoute;